import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getUserInfo } from 'helpers/api';
import { UserInfo } from 'stores/type';
import { ErrorResponse } from 'helpers/type';
import { auth } from '@my-account/tools';
import { getRegion } from 'helpers/tools';
export type UserInfoState = {
    isLoading: boolean;
    isError: boolean;
    error: ErrorResponse | null;
} & UserInfo;

export const initialState: UserInfoState = {
    operation: [],
    region: getRegion(),
    isLoading: true,
    isError: false,
    error: null,
};

export const fetchUserInfo = createAsyncThunk<
    UserInfo,
    void,
    {
        rejectValue: ErrorResponse;
    }
>('FETCH_USER_INFO', async (_arg, thunkApi) => {
    try {
        const userInfoResponse = await getUserInfo();
        return userInfoResponse.data;
    } catch (e) {
        if (e === auth.LOGIN_ERROR_MESSAGE) {
            return thunkApi.rejectWithValue({ message: auth.LOGIN_ERROR_MESSAGE });
        }
        const { message, status } = e.response.data;
        return thunkApi.rejectWithValue({ message, status });
    }
});

const slice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchUserInfo.pending, (state: UserInfoState) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(fetchUserInfo.fulfilled, (state: UserInfoState, action: PayloadAction<UserInfo>) => {
            const { operation, region } = action.payload;
            state.operation = operation;
            state.region = region;
            state.isLoading = false;
        });
        builder.addCase(fetchUserInfo.rejected, (state, action) => {
            state = {
                ...initialState,
                isError: true,
                error: action.payload as NonNullable<typeof action.payload>,
                isLoading: false,
            };
            return state;
        });
    },
});

const reducers = slice.reducer;

export { reducers };
